<template>
  <div class="meeting-mobile">
    <div class="meeting-mobile-disabled__header">
      <h1 class="meeting-mobile__header-title">
        {{ vacancy_title }}
      </h1>
      <div class="meeting-mobile__header-meeting">
        <p class="meeting-mobile__header-date">
          {{ `${dayOfWeek}/${monthAndYer}` }}
        </p>
        <p class="meeting-mobile__header-time">{{ time }}</p>
      </div>
    </div>
    <div class="meeting-mobile__content">
      <p class="meeting-description--markedby">
        <vs-icon icon="person" />
        Entrevista marcada por {{ scheduledBy }}
      </p>
      <p class="meeting-description--address">
        <vs-icon icon="room" />
        {{ place }}
      </p>
      <p v-if="onShowDescription()" class="meeting-description--message">
        <vs-icon class="mr-1" icon="mode_comment" />
        {{ description }}
      </p>
      <div class="meeting-actions">
        <vs-button
          class="w-full"
          icon="check_circle"
          color="#BDC3C7"
          type="filled"
        >
          Convite Expirado
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isSunday,
  isMonday,
  isTuesday,
  isWednesday,
  isThursday,
  isFriday,
  isSaturday,
} from "date-fns";

export default {
  name: "meeting-mobile-card-disabled",
  props: ["meeting"],
  computed: {
    textualDayOfWeek() {
      let textualWeekDay = "";

      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        const date = new Date(splited[2], parseInt(splited[1]) - 1, splited[0]);

        if (isSunday(date)) {
          textualWeekDay = "Domingo";
        }
        if (isMonday(date)) {
          textualWeekDay = "Segunda";
        }
        if (isTuesday(date)) {
          textualWeekDay = "Terça";
        }
        if (isWednesday(date)) {
          textualWeekDay = "Quarta";
        }
        if (isThursday(date)) {
          textualWeekDay = "Quinta";
        }
        if (isFriday(date)) {
          textualWeekDay = "Sexta";
        }
        if (isSaturday(date)) {
          textualWeekDay = "Sábado";
        }
      }
      return textualWeekDay;
    },

    dayOfWeek() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        return splited[0];
      }
      return "";
    },

    monthAndYer() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("date")) {
        const splited = this.meeting.date.split("/");
        const date = new Date(splited[2], parseInt(splited[1]) - 1, splited[0]);

        return date
          .toLocaleString("pt-BR", { month: "long" })
          .slice(0, 3)
          .toUpperCase()
          .concat("/")
          .concat(`${date.toLocaleString("pt-BR", { year: "numeric" })}`);
      }
      return "";
    },

    time() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("time")
        ? this.meeting.time.slice(0, 5)
        : "";
    },

    place() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("place")
        ? this.meeting.place
        : "";
    },

    status() {
      return this.meeting != undefined &&
        this.meeting.hasOwnProperty("meeting_status")
        ? this.meeting.meeting_status["description"]
        : "";
    },

    status_message() {
      return this.meeting != undefined &&
        this.meeting.meeting_status_id == 1 &&
        this.meeting.hasOwnProperty("meeting_status_id")
        ? "Compareça no local e hora indicados"
        : "Esperando o aceite do horário sugerido";
    },

    status_class() {
      return this.meeting != undefined &&
        this.meeting.meeting_status_id == 1 &&
        this.meeting.hasOwnProperty("meeting_status")
        ? "meeting--label__success"
        : "meeting--label__alert";
    },

    meeting_type_description() {
      return this.meeting != undefined &&
        this.meeting.hasOwnProperty("meeting_type")
        ? this.meeting.meeting_type["description"]
        : "";
    },

    vacancy_title() {
      return this.meeting !== undefined &&
        this.meeting !== null &&
        this.meeting.hasOwnProperty("vacancy") &&
        this.meeting.vacancy !== null
        ? this.meeting.vacancy["title"]
        : "Sem título";
    },

    scheduledBy() {
      return this.meeting != undefined && this.meeting.hasOwnProperty("manager")
        ? this.meeting.manager["user"].name
        : "";
    },

    description() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("comment")) {
        if (!this.fullDescription) return this.meeting.comment.slice(0, 184);
        return this.meeting.comment;
      }
      return "";
    },

    showMore() {
      if (this.meeting != undefined && this.meeting.hasOwnProperty("comment")) {
        return this.meeting.comment.length > 184;
      }
    },
  },
  methods: {
    onShowDescription() {
      return (
        this.meeting !== undefined &&
        this.meeting.hasOwnProperty("comment") &&
        this.meeting.comment != null
      );
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/talent/components/meetingmobilecard.scss";
</style>
